export type WaveProps = {
    color?: 'text-white' | string;
    rotation?: '0deg' | string;
    waveType?: '1' | '2' | '3' | '4' | '5' | string;
  };
  
  const Wave = ({ color, rotation, waveType = '1' }: WaveProps) => {
    const boxStyle = {
      transform: `rotateY(${rotation}deg)`,
    };
  
    const pathResolver: { [key: string]: React.ReactNode } = {
      1: (
        <path
          fill="currentColor"
          d="M9425,7024.7s101.127-127.484,440.138,0,839.862,0,839.862,0V7157l-1280,9.861Z"
          transform="translate(-9425.001 -6968.043)"
        />
      ),
      2: (
        <path
          fill="currentColor"
          d="M9425,7025.548s102.635-129.385,446.7,0,833.3-10.071,833.3-10.071v141.659l-1280,12.687Z"
          transform="translate(-9425.001 -6968.044)"
        />
      ),
      3: (
        <path
          fill="currentColor"
          d="M9425,7024.7s90.8-127.485,395.188,0,907.049-35.146,907.049-35.146v177.3H9425Z"
          transform="translate(-9425.001 -6968.044)"
        />
      ),
      4: (
        <path
          fill="currentColor"
          d="M9425,7024.7s103.439-127.484,450.2,0,828.758-92.627,828.758-92.627v222.5L9425,7166.859Z"
          transform="translate(-9425.001 -6932.076)"
        />
      ),
      5: (
        <path
          fill="currentColor"
          d="M10703.962,7024.7s-103.439-127.484-450.2,0S9425,6932.076,9425,6932.076v222.5l1278.961,12.283Z"
          transform="translate(-9425.001 -6932.076)"
        />
      ),
      6: (
        <path
          fill="currentColor"
          d="M9420.085,7082.207s100.355-184.988,447.119-57.5,600.075,0,859.069,0v91.345H9428.085Z"
          transform="translate(-9628.085 -6979.884)"
        />
      ),
    };
  
    return (
      <div
        className={`absolute bottom-[-13px] left-0 right-0 ${color}`}
        style={boxStyle}
      >
        <svg
          id="Layer_2"
          data-name="Layer 2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 915 133.5"
        >
          {pathResolver[waveType || '1']}
        </svg>
      </div>
    );
  };
  
  export default Wave;
  